'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var nextUid = 1;

exports.default = {
  componentWillMount: function componentWillMount() {
    this._uids = {};
  },
  getUniqueId: function getUniqueId(ident) {
    if (!this._uids[ident]) {
      this._uids[ident] = ['uid', ident, nextUid++].join('-');
    }
    return this._uids[ident];
  }
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1552/js/mixins/ComponentWithUniqueIds.js
// module id = 355
// module chunks = 0